import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ENDPOINTS } from '@app/core/constants/endpoints';
import { GDPR_COOKIE_KEY } from '@app/core/constants/storage-keys';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

declare let gtag;

@Component({
    selector: 'app-cookies-consent',
    templateUrl: './cookies-consent.component.html',
    styleUrls: ['./cookies-consent.component.scss'],
    standalone: false,
})
export class CookiesConsentComponent implements OnInit, OnDestroy {
    isGdpr: boolean;
    privacyPoliciesUrl = ENDPOINTS.urls.policies.privacy;

    private subscription: Subscription;

    constructor(private cookies: CookieService, private router: Router) {}

    ngOnInit(): void {
        if (this.cookies.get(GDPR_COOKIE_KEY)) {
            this.isGdpr = true;
        }
    }

    accept(): void {
        /* eslint-disable */
        this.isGdpr = true;
        const navEndEvents$ = this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd)
        );
        this.subscription = navEndEvents$.subscribe((event: NavigationEnd) => {
            gtag('config', 'UA-136822854-1', {
                page_path: event.urlAfterRedirects,
            });
        });
        this.cookies.set(GDPR_COOKIE_KEY, '1', { expires: 365 });
        /* eslint-enable */
    }

    reject(): void {
        this.isGdpr = true;
        this.cookies.set(GDPR_COOKIE_KEY, '0', { expires: 365 });
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
